/**
 * Where the subjects are, worked out from the address and nothing else.
 *
 * `#/subjects` is the list, `#/subjects/new` is the field for a new one with nothing yet created,
 * and `#/subjects/<id>` is one subject opened. The middle one is a *place* rather than a state held
 * in a component, so that the search can send somebody straight into making a subject — and so that
 * a reload lands where they were.
 */

export const SUBJECTS_AREA = 'subjects'

/** The step that means "the field for a new subject has the cursor", without anything being created. */
export const NEW = 'new'

export interface Opened {
  /** Whether the field for a new subject should take the cursor. */
  readonly writing: boolean
  /** The subject that is open, or `null`. */
  readonly subjectId: string | null
}

export function openedIn(path: readonly string[]): Opened {
  const [step] = path
  if (step === undefined) {
    return { writing: false, subjectId: null }
  }
  if (step === NEW) {
    return { writing: true, subjectId: null }
  }
  return { writing: false, subjectId: step }
}

/** The address of one subject. */
export function pathTo(subjectId: string): string[] {
  return [subjectId]
}
